// ================= WHAT A BOUT IS WORTH — THE CLIENT'S COPY =================
//
// A mirror of lib/credits/rules.js, which is the authority. This copy exists so the result screen
// can say "+1 credit" the instant a bout ends, rather than after a round trip that may never come
// back on a bad connection.
//
// IT NEVER DECIDES WHAT IS PAID. The server computes every credit it writes from its own copy, and
// the response carries the real number — so if these two ever disagree, the player sees the
// server's answer and this file's version was only ever a guess that was briefly on screen.
//
// THE TWO ARE HELD EQUAL BY tests/credit-rules-test.js, not by discipline. See the long comment in
// lib/credits/rules.js for why there are two files at all: one is an ES module a Worker imports,
// the other is a classic script loaded from file:// with no build step, and this repo has no
// bundler to bridge them.
window.CREDIT_RULES = (function () {
  'use strict';

  const AWARDS = { win: 1, loss: 0, draw: 0 };
  const DAILY_TIERS = { gold: 15, silver: 10, bronze: 5 };
  const DAILY_CAP = 50;

  function awardFor(result) {
    return Object.prototype.hasOwnProperty.call(AWARDS, result) ? AWARDS[result] : 0;
  }

  return { AWARDS, DAILY_TIERS, DAILY_CAP, awardFor };
})();
